import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_package_failed_crrotw.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-next.svg'
import _imports_3 from '@/app/ui/assets/svg/ellipse.svg'
import _imports_4 from '@/app/ui/assets/svg/ics_o_package_failed_crrpic.svg'
import _imports_5 from '@/app/ui/assets/svg/ics_o_package_failed_crrdon.svg'
import _imports_6 from '@/app/ui/assets/svg/ics_o_package_failed_crrnfd.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7095180d")

_pushScopeId("data-v-7095180d")
const _hoisted_1 = {
  "data-testid": "pickup-dashboard-summary-card",
  class: "py-3 px-4 border border-red-lp-2800",
  style: {"border-radius":"20px"}
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", {
  class: "font-bold text-black-lp-100 text-xl",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}, " Total Pick Up ", -1)
const _hoisted_4 = { class: "flex flex-row items-center gap-3" }
const _hoisted_5 = { class: "text-black-lp-100 flex items-baseline gap-1" }
const _hoisted_6 = {
  class: "font-medium text-xl text-gray-lp-300",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}
const _hoisted_7 = {
  class: "flex flex-row items-center",
  style: {"gap":"6px"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "crrotw"
}, null, -1)
const _hoisted_9 = {
  style: {"line-height":"100%","letter-spacing":"-2%"},
  class: "text-sm text-black-lp-100 font-medium"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  style: {"width":"18px","height":"18px"},
  src: _imports_2,
  alt: "chevron-next"
}, null, -1)
const _hoisted_11 = { class: "pt-3" }
const _hoisted_12 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_13 = { class: "text-sm text-gray-lp-600 font-medium align-middle" }
const _hoisted_14 = { class: "pt-1 flex flex-row items-center gap-2 text-red-lp-100 text-sm font-medium" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  style: {"width":"6px","height":"6px"},
  src: _imports_3
}, null, -1)
const _hoisted_16 = {
  class: "flex flex-row items-center",
  style: {"gap":"6px"}
}
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  alt: "crrpic"
}, null, -1)
const _hoisted_18 = {
  style: {"line-height":"100%","letter-spacing":"-2%"},
  class: "text-sm text-black-lp-100 font-medium"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  style: {"width":"18px","height":"18px"},
  src: _imports_2,
  alt: "chevron-next"
}, null, -1)
const _hoisted_20 = { class: "pt-3" }
const _hoisted_21 = { class: "flex flex-row items-center gap-2" }
const _hoisted_22 = { class: "text-sm text-gray-lp-600 font-medium align-middle" }
const _hoisted_23 = { class: "pt-1 flex flex-row items-center gap-2 text-red-lp-100 text-sm font-medium" }
const _hoisted_24 = {
  class: "flex flex-row items-center",
  style: {"gap":"6px"}
}
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  alt: "crrdon"
}, null, -1)
const _hoisted_26 = {
  style: {"line-height":"100%","letter-spacing":"-2%"},
  class: "text-sm text-black-lp-100 font-medium"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  style: {"width":"18px","height":"18px"},
  src: _imports_2,
  alt: "chevron-next"
}, null, -1)
const _hoisted_28 = { class: "pt-3" }
const _hoisted_29 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_30 = { class: "text-sm text-gray-lp-600 font-medium align-middle" }
const _hoisted_31 = { class: "pt-1 flex flex-row items-center gap-2 text-red-lp-100 text-sm font-medium" }
const _hoisted_32 = {
  class: "flex flex-row items-center",
  style: {"gap":"6px"}
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  alt: "crrnfd"
}, null, -1)
const _hoisted_34 = {
  style: {"line-height":"100%","letter-spacing":"-2%"},
  class: "text-sm text-black-lp-100 font-medium"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("img", {
  style: {"width":"18px","height":"18px"},
  src: _imports_2,
  alt: "chevron-next"
}, null, -1)
const _hoisted_36 = { class: "pt-3" }
const _hoisted_37 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_38 = { class: "text-sm text-gray-lp-600 font-medium align-middle" }
const _hoisted_39 = { class: "pt-1 flex flex-row items-center gap-1 text-yellow-lp-100 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("p", _hoisted_5, [
          _createVNode("span", {
            "data-testid": "pickup-dashboard-summary-total-shipment",
            class: "text-3xl font-bold",
            style: {"line-height":"100%","letter-spacing":"-2%"},
            title: _ctx.formatByCountry(_ctx.totalShipments, { type: 'quantity' })
          }, _toDisplayString(_ctx.formatCompactNumber(_ctx.totalShipments)), 9, ["title"]),
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('pickupDashboard.package')), 1),
          _createVNode("span", {
            "data-testid": "pickup-dashboard-summary-total-quantity",
            style: {"line-height":"100%","letter-spacing":"-2%"},
            title: _ctx.formatByCountry(_ctx.totalQuantities, { type: 'quantity' })
          }, " (" + _toDisplayString(_ctx.formatCompactNumber(_ctx.totalQuantities)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.koli')) + ") ", 9, ["title"])
        ]),
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
        }, [
          _createVNode("img", {
            class: ["w-5 h-5 mt-2 transform rotate-180", [
              {'chevron-up': _ctx.isOpen}
            ]],
            src: _imports_0,
            alt: "chevron-up"
          }, null, 2)
        ])
      ])
    ]),
    _createVNode("div", {
      class: ["grid grid-cols-4 pt-0 gap-x-4 max-h-0 h-0 overflow-hidden", [
        {'pt-3': _ctx.isOpen},
        {'h-max-content': _ctx.isOpen},
        {'max-h-full': _ctx.isOpen}
      ]]
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localData, (data) => {
        return (_openBlock(), _createBlock("div", {
          key: data.status,
          class: "rounded-2xl p-3 border border-red-lp-2800",
          style: {
          backgroundImage: `url(${require(data.status === 'CRRNFD' ? '@/app/ui/assets/svg/bg-summary-card-yellow.svg' : '@/app/ui/assets/svg/bg-summary-card.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
          backgroundSize: '-100% 50%'
        }
        }, [
          (data.status === 'CRROTW')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: `/pickup-dashboard/monitoring/all-pickup/crrotw?start_date=${_ctx.filterStartDate}&end_date=${_ctx.filterEndDate}`
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('pickupDashboard.belumDiPickUp')), 1),
                    _hoisted_10
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", {
                        class: "text-2xl text-black-lp-100 font-bold",
                        style: {"line-height":"100%","letter-spacing":"-2%"},
                        title: _ctx.formatByCountry(data.seller, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.seller)), 9, ["title"]),
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('pickupDashboard.sender')), 1)
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", {
                        title: _ctx.formatByCountry(data.shipment, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.shipment)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.package')), 9, ["title"]),
                      _hoisted_15,
                      _createVNode("div", {
                        title: _ctx.formatByCountry(data.courier, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.courier)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.courier')), 9, ["title"])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true),
          (data.status === 'CRRPIC')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: `/pickup-dashboard/monitoring/all-pickup/crrpic?start_date=${_ctx.filterStartDate}&end_date=${_ctx.filterEndDate}`
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('pickupDashboard.belumDisetor')), 1),
                    _hoisted_19
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", {
                        class: "text-2xl text-black-lp-100 font-bold",
                        style: {"line-height":"100%","letter-spacing":"-2%"},
                        title: _ctx.formatByCountry(data.courier, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.courier)), 9, ["title"]),
                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('pickupDashboard.courier')), 1)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", {
                        title: _ctx.formatByCountry(data.shipment, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.shipment)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.shipment')), 9, ["title"])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true),
          (data.status === 'CRRDON')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: `/pickup-dashboard/monitoring/all-pickup/crrdon?start_date=${_ctx.filterStartDate}&end_date=${_ctx.filterEndDate}`
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('pickupDashboard.belumBkd')), 1),
                    _hoisted_27
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", {
                        class: "text-2xl text-black-lp-100 font-bold",
                        style: {"line-height":"100%","letter-spacing":"-2%"},
                        title: _ctx.formatByCountry(data.shipment, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.shipment)), 9, ["title"]),
                      _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('pickupDashboard.package')), 1),
                      _createVNode("div", {
                        title: _ctx.formatByCountry(data.quantity, { type: 'quantity' }),
                        class: "text-sm font-medium text-gray-lp-600"
                      }, "(" + _toDisplayString(_ctx.formatCompactNumber(data.quantity)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.koli')) + ")", 9, ["title"])
                    ]),
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", {
                        title: _ctx.formatByCountry(data.courier, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.courier)) + " " + _toDisplayString(_ctx.$t('pickupDashboard.courier')), 9, ["title"])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true),
          (data.status === 'CRRNFD')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                to: `/pickup-dashboard/monitoring/all-pickup/crrnfd?start_date=${_ctx.filterStartDate}&end_date=${_ctx.filterEndDate}`
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('pickupDashboard.belumDiassign')), 1),
                    _hoisted_35
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _createVNode("div", {
                        class: "text-2xl text-black-lp-100 font-bold",
                        style: {"line-height":"100%","letter-spacing":"-2%"},
                        title: _ctx.formatByCountry(data.seller, { type: 'quantity' })
                      }, _toDisplayString(_ctx.formatCompactNumber(data.seller)), 9, ["title"]),
                      _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('pickupDashboard.sender')), 1)
                    ]),
                    _createVNode("div", _hoisted_39, [
                      _createVNode(_component_Icons, {
                        style: {"width":"18px","height":"18px"},
                        name: "info"
                      }),
                      _createVNode("div", null, _toDisplayString(_ctx.$t('pickupDashboard.waitingAssign')), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true)
        ], 4))
      }), 128))
    ], 2)
  ]))
})